/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { ProductDTO } from './ProductDTO';
import {
    ProductDTOFromJSON,
    ProductDTOFromJSONTyped,
    ProductDTOToJSON,
} from './ProductDTO';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * 
 * @export
 * @interface ProductPageDTO
 */
export interface ProductPageDTO {
    /**
     * 
     * @type {Array<ProductDTO>}
     * @memberof ProductPageDTO
     */
    content?: Array<ProductDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof ProductPageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProductPageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductPageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof ProductPageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof ProductPageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof ProductPageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof ProductPageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof ProductPageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the ProductPageDTO interface.
 */
export function instanceOfProductPageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProductPageDTOFromJSON(json: any): ProductPageDTO {
    return ProductPageDTOFromJSONTyped(json, false);
}

export function ProductPageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductPageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(ProductDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function ProductPageDTOToJSON(value?: ProductPageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(ProductDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

